module.exports = __webpack_public_path__ + "img/im.b2a85483.svg";